import { useState } from 'react';
import { CHORD_NAMES } from '@gc/shared';
import { ChordCard } from '../components/Chords.js';
import { StrumTrainer } from '../components/StrumTrainer.js';
import { TabPlayer } from '../components/TabPlayer.js';
import { Tuner } from '../components/Tuner.js';

export interface TrainersProps {
  /** Что открыть сразу: kind = tuner | chord | strum | tab. */
  target?: { kind: string; id: string };
}

const TABS = [
  ['tuner', 'Струны'],
  ['chord', 'Аккорды'],
  ['strum', 'Бой'],
  ['tab', 'Табы'],
] as const;

export function Trainers({ target }: TrainersProps): JSX.Element {
  const [tab, setTab] = useState<string>(target?.kind ?? 'tuner');

  return (
    <div className="screen">
      <div className="chips sticky">
        {TABS.map(([key, label]) => (
          <button
            key={key}
            type="button"
            className="chip"
            aria-pressed={tab === key}
            onClick={() => setTab(key)}
          >
            {label}
          </button>
        ))}
      </div>

      {tab === 'tuner' && <Tuner />}

      {tab === 'chord' && (
        <div className="chord-grid">
          {CHORD_NAMES.map((name) => (
            <ChordCard key={name} name={name} active={target?.kind === 'chord' && target.id === name} />
          ))}
        </div>
      )}

      {tab === 'strum' && <StrumTrainer initial={target?.kind === 'strum' ? target.id : undefined} />}

      {tab === 'tab' && <TabPlayer initial={target?.kind === 'tab' ? target.id : undefined} />}
    </div>
  );
}
